var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Menu } from '@headlessui/react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { store, useAppSelector } from '../../../../../store';
import { participantsSelector } from '../../../../../store/slices/participantSlice';
import { sendWebsocketMessage } from '../../../../../helpers/websocket';
import sendAPIRequest from '../../../../../helpers/api/plugNmeetAPI';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../../../../helpers/proto/plugnmeet_datamessage_pb';
import { CommonResponse, MuteUnMuteTrackReq, } from '../../../../../helpers/proto/plugnmeet_common_api_pb';
const MicMenuItem = ({ userId }) => {
    var _a;
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const session = store.getState().session;
    const [text, setText] = useState('Ask to share Microphone');
    const [task, setTask] = useState('');
    const { t } = useTranslation();
    useEffect(() => {
        if ((participant === null || participant === void 0 ? void 0 : participant.audioTracks) === 0) {
            setText(t('left-panel.menus.items.ask-to-share-microphone').toString());
            setTask('left-panel.menus.items.share-microphone');
        }
        else if (participant === null || participant === void 0 ? void 0 : participant.isMuted) {
            setText(t('left-panel.menus.items.ask-to-unmute-mic').toString());
            setTask('left-panel.menus.items.unmute-mic');
        }
        else if (participant === null || participant === void 0 ? void 0 : participant.audioTracks) {
            setText(t('left-panel.menus.items.mute-mic').toString());
            setTask('mute');
        }
    }, [t, participant === null || participant === void 0 ? void 0 : participant.isMuted, participant === null || participant === void 0 ? void 0 : participant.audioTracks]);
    const onClick = () => {
        var _a, _b, _c, _d, _e;
        if (task === 'mute') {
            muteAudio();
            return;
        }
        const dataMsg = new DataMessage({
            type: DataMsgType.SYSTEM,
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            to: userId,
            body: {
                type: DataMsgBodyType.INFO,
                from: {
                    sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                    userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                },
                msg: t('left-panel.menus.notice.asked-you-to', {
                    name: (_e = session.currentUser) === null || _e === void 0 ? void 0 : _e.name,
                }) + t(task),
            },
        });
        sendWebsocketMessage(dataMsg.toBinary());
        toast(t('left-panel.menus.notice.you-have-asked', {
            name: participant === null || participant === void 0 ? void 0 : participant.name,
        }) + t(task), {
            toastId: 'asked-status',
            type: 'info',
        });
    };
    const muteAudio = async () => {
        const session = store.getState().session;
        const body = new MuteUnMuteTrackReq({
            sid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            userId: participant === null || participant === void 0 ? void 0 : participant.userId,
            muted: true,
        });
        const r = await sendAPIRequest('muteUnmuteTrack', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.you-have-muted-to', {
                name: participant === null || participant === void 0 ? void 0 : participant.name,
            }), {
                toastId: 'asked-status',
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                toastId: 'asked-status',
                type: 'error',
            });
        }
    };
    const render = () => {
        return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-gray-900 dark:text-darkText group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-primaryColor hover:text-white", onClick: () => onClick(), children: text })) }) }));
    };
    return (_jsx(_Fragment, { children: ((_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.userId) !== (participant === null || participant === void 0 ? void 0 : participant.userId) ? render() : null }));
};
_react_refresh_temp_1 = MicMenuItem;
$RefreshReg$(_react_refresh_temp_1, "MicMenuItem");
_react_refresh_temp_2(MicMenuItem, "Dro2QhX2TdK8XOQQRkLb/N3hxR4=", false, () => [useAppSelector, useTranslation]);
export default MicMenuItem;
